module.exports = __webpack_public_path__ + "static/media/wireless-auditing.2632e7ca.png";